import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Container,
  ListGroup,
  ListGroupItem,
  Spinner,
  Offcanvas,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchJobUniversalReportCount,
  editReportCustomViewById,
  fetchJobUniversalReportJobCount,
} from "../../store/report/action";
import {
  fetchReportCustomView,
  resetReportCustomView,
  setDefaultCustomView,
  deleteDefaultCustomView,
  deleteJobDefaultCustomView,
} from "../../store/report/action";
import ReportOffcanvas from "./ReportOffcanvas/ReportOffcanvas";
import "./UniversalReport.scss";
import {
  REPORT_CATEGORY,
  INITIAL_REPORT_FILTER,
  getReportsData,
  REPORTS_NAME,
  NOT_CLICKABLE_REPORTS,
  FILTER_LABELS,
  CUSTOM_VIEW_TYPE,
  FORM_NAME,
  JOB_ICONS,
  getReportInformation,
  generateReportData,
  reportTypeBorder,
} from "./UniversalReportConstant";
import "react-day-picker/dist/style.css";
import { ArrayHelper } from "@workspace/common";
import Calendar from "./components/Calendar";
import CurrentStageFilter from "./components/CurrentStageFilter";
import { FilterBubbles, InformationToolTip } from "@workspace/common";
import { fetchCandidateForm } from "@workspace/candidate/src/store/candidateForm/action";
import { fetchJobForm } from "@workspace/job/src/store/jobForm/action";
import { fetchUsers } from "@workspace/common/src/store/actions";
import { fetchCountryCurrency } from "@workspace/common/src/store/actions";
import ReportOffcanvasJob from "./ReportOffcanvasJob/ReportOffcanvasJob";
import JobReportCustomViewCanvas from "./ReportOffcanvasJob/CustomView/JobReportCustomViewCanvas";
import { fetchAccountNamesAll } from "@workspace/common/src/store/accountnames/action";
import TimelineCustomView from "./TimelineCustomView/TimelineCustomView";
import ExternalFilter from "./ExternalFilter/ExternalFilter";
import { fetchAccountOwners } from "@workspace/account/src/store/account/action";
import ReportCountDownload from "./components/ReportCountDownload";
import UniversalReportProvider from "./context/UniversalReportProvider";

function UniversalReport() {
  document.title = "Universal Report | RTS";
  const dispatch = useDispatch();
  const reportCount = useSelector(
    (state) => state?.ReportReducer?.jobUniversalReportCount
  );
  const jobReportCustomViews = useSelector(
    (state) => state?.ReportReducer?.reportCustomViews
  );
  const reportCountMeta = useSelector(
    (state) => state?.ReportReducer?.jobUniversalReportCountMeta
  );
  const defaultCustomView = useSelector(
    (state) => state?.ReportReducer?.defaultCustomView
  );

  const jobReportCount = useSelector(
    (state) => state?.ReportReducer?.jobUniversalReportJobCount
  );

  const jobReportJobCustomViews = useSelector(
    (state) => state?.ReportReducer?.jobReportCustomViews
  );

  const reportJobCountMeta = useSelector(
    (state) => state?.ReportReducer?.jobUniversalReportJobCountMeta
  );

  const jobDefaultCustomView = useSelector(
    (state) => state?.ReportReducer?.jobDefaultCustomView
  );

  const [isReportOffcanvasOpen, setIsReportOffcanvasOpen] = useState(false);
  const [isCustomViewOpen, setIsCustomViewOpen] = useState(false);
  const [isJobCustomViewOpen, setIsJobCustomViewOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [filterCustomView, setFilterCustomView] = useState(
    INITIAL_REPORT_FILTER
  );
  const [selectedDates, setSelectedDates] = useState(null);
  const [currentStage, setCurrentStage] = useState(null);
  const [customView, setCustomView] = useState(null);
  const [jobCustomView, setJobCustomView] = useState(null);
  // Filters
  const [bubbleExternalFilter, setBubbleExternalFilter] = useState(null);
  const [jobBubbleExternalFilter, setJobBubbleExternalFilter] = useState(null);

  const [isDateOpen, setIsDateOpen] = useState(true);

  const initializeSelectedDates = () => {
    setSelectedDates(null);
  };

  const initializeCurrentStage = () => {
    setCurrentStage(null);
  };

  const initializeDefaultFilterStages = () => {
    initializeSelectedDates();
    initializeCurrentStage();
  };

  useEffect(() => {
    dispatch(fetchReportCustomView(CUSTOM_VIEW_TYPE.JOB_UNIVERSAL_REPORT));
    dispatch(
      fetchReportCustomView(CUSTOM_VIEW_TYPE.JOB_UNIVERSAL_REPORT_JOB_LISTING)
    );
    dispatch(fetchJobForm(FORM_NAME.JOB));
    dispatch(fetchCandidateForm(FORM_NAME.CANDIDATE));
    dispatch(fetchUsers());
    dispatch(fetchAccountNamesAll());
    dispatch(fetchCountryCurrency());
    dispatch(fetchAccountOwners());

    return () => {
      dispatch(resetReportCustomView());
      dispatch(deleteDefaultCustomView());
      dispatch(deleteJobDefaultCustomView());
    };
  }, []);

  // Job Timeline Custom View Initalization
  useEffect(() => {
    if (jobReportCustomViews != null && jobReportCustomViews?.length > 0) {
      const selectedCustomView = jobReportCustomViews?.find(
        (customView) => customView?.selected
      );
      if (selectedCustomView) {
        setCustomView(selectedCustomView);
        initializeDefaultFilterStages();
      } else {
        setCustomView(-1);
      }
    }
    if (jobReportCustomViews != null && jobReportCustomViews?.length === 0) {
      setCustomView(-1);
    }
  }, [jobReportCustomViews]);

  // Job Listing initialization
  useEffect(() => {
    if (
      jobReportJobCustomViews != null &&
      jobReportJobCustomViews?.length > 0
    ) {
      const selectedCustomView = jobReportJobCustomViews?.find(
        (customView) => customView?.selected
      );
      if (selectedCustomView) {
        setJobCustomView(selectedCustomView);
        initializeDefaultFilterStages();
      } else {
        setJobCustomView(-1);
      }
    }
    if (
      jobReportJobCustomViews != null &&
      jobReportJobCustomViews?.length === 0
    ) {
      setJobCustomView(-1);
    }
  }, [jobReportJobCustomViews]);

  const isEmpty = (obj) => Object.entries(obj).length === 0;

  // Timeline Bubble Filter Setting
  useEffect(() => {
    if (bubbleExternalFilter == null) {
      if (customView != null) {
        if (customView != -1) {
          setBubbleExternalFilter(customView?.filters);
        } else if (defaultCustomView) {
          if (isEmpty(defaultCustomView)) {
            setBubbleExternalFilter([]);
          } else {
            setBubbleExternalFilter(defaultCustomView?.filters);
          }
        }
      }
    }
  }, [customView, defaultCustomView]);

  // Job Listing Bubble Filter Setting
  useEffect(() => {
    if (jobBubbleExternalFilter == null) {
      if (jobCustomView != null) {
        if (jobCustomView != -1) {
          setJobBubbleExternalFilter(jobCustomView?.filters);
        } else if (jobDefaultCustomView) {
          if (isEmpty(jobDefaultCustomView)) {
            setJobBubbleExternalFilter([]);
          } else {
            setJobBubbleExternalFilter(jobDefaultCustomView?.filters);
          }
        }
      }
    }
  }, [jobCustomView, jobDefaultCustomView]);

  useEffect(() => {
    if (bubbleExternalFilter != null) {
      if (customView != null && customView != -1) {
        dispatch(
          fetchJobUniversalReportCount({
            page: 0,
            pageSize: 9999,
            sortBy: null,
            sortDirection: "asc",
            searchTerm: null,
            jobStep: selectedItem?.value || "",
            filters: bubbleExternalFilter || customView?.filters || [],
            externalFilters: customView?.externalFilters || [],
          })
        );
      }

      if (customView == null || customView == -1) {
        dispatch(
          fetchJobUniversalReportCount({
            page: 0,
            pageSize: 999999,
            sortBy: null,
            sortDirection: "asc",
            searchTerm: null,
            jobStep: selectedItem?.value || "",
            filters: bubbleExternalFilter || defaultCustomView?.filters || [],
            externalFilters: defaultCustomView?.externalFilters || [],
          })
        );
      }
    }
  }, [
    customView?.externalFilters,
    customView,
    defaultCustomView?.externalFilters,
    bubbleExternalFilter,
  ]);

  useEffect(() => {
    if (jobBubbleExternalFilter != null) {
      if (jobCustomView != null && jobCustomView != -1) {
        dispatch(
          fetchJobUniversalReportJobCount({
            page: 0,
            pageSize: 9999,
            sortBy: null,
            sortDirection: "asc",
            searchTerm: null,
            jobStep: selectedItem?.value || "",
            filters: jobBubbleExternalFilter || jobCustomView?.filters || [],
            externalFilters:
              customView?.externalFilters ||
              defaultCustomView?.externalFilters ||
              [],
          })
        );
      }

      if (jobCustomView == null || jobCustomView == -1) {
        dispatch(
          fetchJobUniversalReportJobCount({
            page: 0,
            pageSize: 999999,
            sortBy: null,
            sortDirection: "asc",
            searchTerm: null,
            jobStep: selectedItem?.value || "",
            filters:
              jobBubbleExternalFilter || jobDefaultCustomView?.filters || [],
            externalFilters:
              customView?.externalFilters ||
              defaultCustomView?.externalFilters ||
              [],
          })
        );
      }
    }
  }, [
    jobCustomView?.filters,
    jobCustomView,
    jobDefaultCustomView?.filters,
    jobBubbleExternalFilter,
    defaultCustomView?.externalFilters,
    customView?.externalFilters,
  ]);

  useEffect(() => {
    // Let merge into default external filter default
    if (
      (customView == null || customView == -1) &&
      (currentStage || selectedDates)
    ) {
      let newExternalFiltersDefault = [
        {
          label: FILTER_LABELS.dateRange,
          value: null,
          value2: null,
        },
        {
          label: FILTER_LABELS.currentStage,
          value: null,
        },
      ];
      if (defaultCustomView?.externalFilters != null) {
        newExternalFiltersDefault = JSON.parse(
          JSON.stringify(defaultCustomView?.externalFilters)
        );
      }

      if (currentStage) {
        newExternalFiltersDefault[1] = currentStage;
      }

      if (selectedDates) {
        newExternalFiltersDefault[0] = selectedDates;
      }
      const newDefaultCustomView = JSON.parse(
        JSON.stringify(defaultCustomView)
      );
      newDefaultCustomView.externalFilters = newExternalFiltersDefault;
      dispatch(setDefaultCustomView(newDefaultCustomView));
    }
  }, [currentStage, selectedDates]);

  // Required soon. Do not remove
  // useEffect(() => {
  //   // Let merge into default external filter default
  //   if (jobCustomView == null && (selectedDates)) {
  //     let newExternalFiltersDefault = [
  //       {
  //         label: "Date Range",
  //         value: null,
  //         value2: null,
  //       },
  //     ];
  //     if (jobDefaultCustomView?.externalFilters != null) {
  //       newExternalFiltersDefault = JSON.parse(
  //         JSON.stringify(jobDefaultCustomView?.externalFilters)
  //       );
  //     }

  //     if (selectedDates) {
  //       newExternalFiltersDefault[0] = selectedDates;
  //     }
  //     const newDefaultCustomView = JSON.parse(
  //       JSON.stringify(jobDefaultCustomView)
  //     );
  //     newDefaultCustomView.externalFilters = newExternalFiltersDefault;
  //     dispatch(setJobDefaultCustomView(newDefaultCustomView));
  //   }
  // }, [selectedDates]);

  const applyDateRange = async (dates) => {
    if (customView == null || customView == -1) return;
    const newCustomView = {
      ...JSON.parse(JSON.stringify(customView)),
      columnName: ArrayHelper.convertCommaSeperatedToArray(
        customView?.columnName
      ),
    };

    const dateData = {
      value: dates.value,
      value2: dates.value2,
      label: FILTER_LABELS.dateRange,
    };

    if (newCustomView?.externalFilters == null) {
      newCustomView.externalFilters = [dateData];
    } else {
      const dateRangeFilter = newCustomView?.externalFilters.find(
        (filter) => filter?.label === FILTER_LABELS.dateRange
      );
      if (dateRangeFilter) {
        dateRangeFilter.value = dates.value;
        dateRangeFilter.value2 = dates.value2;
        dateRangeFilter.label = FILTER_LABELS.dateRange;
      } else {
        newCustomView.externalFilters.push(dateData);
      }
    }

    dispatch(
      editReportCustomViewById({
        editId: customView?.id,
        payload: newCustomView,
      })
    );
  };

  const handleCurrentStage = (data) => {
    if (customView == null || customView == -1) {
    } else {
      const newCustomView = {
        ...JSON.parse(JSON.stringify(customView)),
        columnName: ArrayHelper.convertCommaSeperatedToArray(
          customView?.columnName
        ),
      };

      // Check if null then add it
      if (newCustomView?.externalFilters == null) {
        newCustomView.externalFilters = [data];
      } else {
        const currentStageRangeFilter = newCustomView?.externalFilters.find(
          (filter) => filter?.label === data?.label
        );
        if (currentStageRangeFilter) {
          currentStageRangeFilter.value = data?.value;
          currentStageRangeFilter.label = data?.label;
          currentStageRangeFilter.externalFilter = data?.externalFilter;
        } else {
          newCustomView.externalFilters.push(data);
        }
      }
      dispatch(
        editReportCustomViewById({
          editId: customView?.id,
          payload: newCustomView,
        })
      );
    }
  };

  const checkIsCurrentStage = () => {
    if (customView && customView !== -1) {
      return (
        getCurrentStageFilter(customView?.externalFilters)?.value === "true" ||
        getCurrentStageFilter(customView?.externalFilters)?.value === true
      );
    } else if (defaultCustomView) {
      return (
        getCurrentStageFilter(defaultCustomView?.externalFilters)?.value ===
          "true" ||
        getCurrentStageFilter(defaultCustomView?.externalFilters)?.value ===
          true
      );
    }
  };

  const getReportCount = (reportCategory, reportName) => {
    switch (reportCategory) {
      case REPORT_CATEGORY.JOBS:
        switch (reportName) {
          case REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_JOBS:
            return jobReportCount?.totalRequirementsCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS]
            .TOTAL_JOBS_ASSIGNED_TO_RECRUITERS:
            return jobReportCount?.allAssignedRequirementsCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_ACTIVE_JOBS:
            return jobReportCount?.activeRequirementsCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_INACTIVE_JOBS:
            return jobReportCount?.inactiveRequirementsCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_CLOSED_WIN_JOBS:
            return jobReportCount?.closedWinRequirementsCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS].TOTAL_CLOSED_LOST_JOBS:
            return jobReportCount?.closedLostRequirementsCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS].NEW_JOBS:
            return jobReportCount?.newRequirementsCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS]
            .TOTAL_HEAD_COUNTS_POSITIONS_ACTIVE_JOBS:
            return jobReportCount?.activeJobHeadCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS]
            .TOTAL_HEAD_COUNTS_POSITIONS_NEW_JOBS:
            return jobReportCount?.newJobHeadCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS].NO_SUBMISSIONS:
            return jobReportCount?.noSubmissionsJobCount;
          default:
            return;
        }
      case REPORT_CATEGORY.JOBS_FOD:
        switch (reportName) {
          case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_TOTAL:
            return jobReportCount?.fodTotalCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_ACTION_TAKEN:
            return jobReportCount?.fodActionTakenCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_NO_ACTION:
            return jobReportCount?.fodNoActionCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_TOTAL_R:
            return jobReportCount?.fodTotalRCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_ACTION_TAKEN_R:
            return jobReportCount?.fodActionTakenRCount;
          case REPORTS_NAME[REPORT_CATEGORY.JOBS_FOD].FOD_NO_ACTION_R:
            return jobReportCount?.fodNoActionRCount;
          default:
            return;
        }
      case REPORT_CATEGORY.GROWTH_RATIO:
        switch (reportName) {
          case REPORTS_NAME[REPORT_CATEGORY.GROWTH_RATIO].NEW_JOB:
            return 0;
          case REPORTS_NAME[REPORT_CATEGORY.GROWTH_RATIO].SUBMITTED_TO_CLIENT:
            return 0;
          default:
            return;
        }
      case REPORT_CATEGORY.PROFILES:
        switch (reportName) {
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].FOD_TOTAL:
            return reportCount?.fodTotalCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES]
            .ACTIVE_RECRUITERS_DISTINCT:
            return reportCount?.activeRecruitersCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].ACTIVE_RECRUITERS:
            return `${reportCount?.activeRecruitersCount || 0} (${
              reportCount?.activeRecruitersListingCount || 0
            })`;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].CURRENT_ENGAGEMENTS:
            return `${reportCount?.currentEngagementsCount || 0} (${
              reportCount?.currentEngagementsListingCount || 0
            })`;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].TAG:
            return reportCount?.taggedCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].ASSOCIATED:
            return reportCount?.associatedCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].SUBMITTED_TO_SALES:
            return reportCount?.submitToSalesCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].SUBMITTED_TO_CLIENT:
            return reportCount?.submitToClientCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].PROFILE_FEEDBACK_PENDING:
            return reportCount?.profileFeedbackCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].CANDIDATE_WITHDRAWN:
            return reportCount?.profileWithdrawnCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].PROFILE_REJECTED_BY_SALES:
            return reportCount?.submitToSalesRejectedCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES]
            .PROFILE_REJECTED_BY_CLIENT:
            return reportCount?.submitToClientRejectedCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].NO_SUBMISSIONS:
            return reportCount?.noSubmissionsCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES].REQUIREMENTS_WORKED_ON:
            return reportCount?.requirementsWorkedOnCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES]
            .PROFILE_SUBMITTED_TO_INTERVIEWS_HAPPENED:
            return reportCount?.profileSubmittedToInterviewsCount;
          case REPORTS_NAME[REPORT_CATEGORY.PROFILES]
            .INTERVIEW_HAPPENED_TO_SELECTED:
            return reportCount?.interviewHappenedToSelectedCount;
          default:
            return;
        }
      case REPORT_CATEGORY.INTERVIEWS:
        switch (reportName) {
          case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].SCHEDULED_INTERVIEW:
            if (checkIsCurrentStage()) {
              return reportCount?.interviewScheduledCount;
            }
            const firstInterviewScheduleCount =
              reportCount?.interviewScheduledFirstCount || 0;
            const secondInterviewScheduleCount =
              reportCount?.interviewScheduledSecondCount || 0;
            const thirdInterviewScheduleCount =
              reportCount?.interviewScheduledThirdCount || 0;
            return (
              firstInterviewScheduleCount +
              secondInterviewScheduleCount +
              thirdInterviewScheduleCount
            );
          case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].RESCHEDULE_INTERVIEW:
            return reportCount?.rescheduleInterviewCount;
          case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].INTERVIEW_HAPPENED:
            if (checkIsCurrentStage()) {
              return reportCount?.interviewHappenedCount;
            }
            const interviewHappenedFirstCount =
              reportCount?.interviewHappenedFirstCount || 0;
            const interviewHappenedSecondCount =
              reportCount?.interviewHappenedSecondCount || 0;
            const interviewHappenedThirdCount =
              reportCount?.interviewHappenedThirdCount || 0;
            return (
              interviewHappenedFirstCount +
              interviewHappenedSecondCount +
              interviewHappenedThirdCount
            );
          case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS]
            .INTERVIEW_BACKOUT_BY_CANDIDATE:
            return reportCount?.interviewBackOutCount;
          case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS]
            .INTERVIEW_REJECTED_BY_CLIENT:
            return reportCount?.interviewRejectedCount;
          case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].UPCOMING_INTERVIEWS:
            return reportCount?.upcomingInterviewsCount;
          case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].UNASSIGNED_REQUIREMENTS:
            return reportCount?.unassignedRequirementsCount;
          case REPORTS_NAME[REPORT_CATEGORY.INTERVIEWS].NEW_JOB_TO_SELECTED:
            return reportCount?.interviewFeedbackPendingCount;
          default:
            return;
        }
      case REPORT_CATEGORY.CONDITIONAL_OFFERS:
        switch (reportName) {
          case REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].PREPARED:
            return reportCount?.conditionalOfferPreparedCount;
          case REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].RELEASED:
            return reportCount?.conditionalOfferReleasedCount;
          case REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].ACCEPTED:
            return reportCount?.conditionalOfferAcceptedCount;
          case REPORTS_NAME[REPORT_CATEGORY.CONDITIONAL_OFFERS].REJECTED:
            return reportCount?.conditionalOfferRejectedCount;
          default:
            return;
        }
      case REPORT_CATEGORY.TOS:
        switch (reportName) {
          case REPORTS_NAME[REPORT_CATEGORY.TOS].PREPARED:
            return reportCount?.tosPreparedCount;
          case REPORTS_NAME[REPORT_CATEGORY.TOS].APPROVED:
            return reportCount?.tosApprovedCount;
          case REPORTS_NAME[REPORT_CATEGORY.TOS].REJECTED:
            return reportCount?.tosRejectedCount;
          default:
            return;
        }
      default:
        return;
    }
  };

  useEffect(() => {
    if (!isReportOffcanvasOpen) {
      setSelectedItem({});
    }
  }, [isReportOffcanvasOpen]);

  const getDateObj = (filters) => {
    return (
      filters?.find((filter) => filter.label === FILTER_LABELS.dateRange) ||
      null
    );
  };

  const getCurrentStageFilter = (filters) => {
    return filters?.find(
      (filter) => filter.label === FILTER_LABELS.currentStage
    );
  };

  const generateOffCanvas = (reportCategory, reportName) => {
    switch (reportCategory) {
      case REPORT_CATEGORY.JOBS:
      case REPORT_CATEGORY.JOBS_FOD:
        return (
          <ReportOffcanvasJob
            isReportOffcanvasOpen={isReportOffcanvasOpen}
            setIsReportOffcanvasOpen={setIsReportOffcanvasOpen}
            selectedItem={selectedItem}
            filters={filterCustomView}
            customView={jobCustomView}
            defaultCustomView={jobDefaultCustomView}
            jobBubbleExternalFilter={jobBubbleExternalFilter}
            setJobBubbleExternalFilter={setJobBubbleExternalFilter}
            timelineCustomView={customView}
          />
        );
      default:
        return (
          <ReportOffcanvas
            isReportOffcanvasOpen={isReportOffcanvasOpen}
            setIsReportOffcanvasOpen={setIsReportOffcanvasOpen}
            selectedItem={selectedItem}
            filters={filterCustomView}
            customView={customView}
            defaultCustomView={defaultCustomView}
            bubbleExternalFilter={bubbleExternalFilter}
          />
        );
    }
  };

  const getJobIcons = (reportName) => {
    return JOB_ICONS[reportName];
  };

  const labelStyle = {
    borderBottom: "1px solid #D3D3D3",
    padding: "3px",
    borderColor: "#D3D3D3",
  };

  const getCurrentDatetimeString = () => {
    const date = new Date();
    return `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}__${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`;
  };

  return (
    <UniversalReportProvider>
      <div className="page-content bg-white">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <div
                className="page-title-box d-sm-flex flex-column align-items-start justify-content-between"
                style={{
                  marginBottom: "15px",
                }}
              >
                <div className="d-flex align-items-start gap-2 flex-wrap">
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      minWidth: "100%",
                    }}
                  >
                    <div className="d-flex flex-row justify-content-center align-items-center gap-2 mt-1 pe-2">
                      <div className="report-top-header-text mb-sm-0">
                        Report
                      </div>
                      <span style={{ color: "#0a56ae", fontWeight: "500" }}>
                        {customView?.name || "Default View"}
                      </span>
                    </div>
                    <div className="d-flex gap-2">
                      <ReportCountDownload
                        reportData={generateReportData(
                          reportCount,
                          jobReportCount,
                          checkIsCurrentStage
                        )}
                        fileName={`Report_${getCurrentDatetimeString()}`}
                      >
                        <Button className="report-listing-filter-btn">
                          <i
                            className="ri-download-fill align-bottom"
                            style={{
                              fontSize: "14px",
                            }}
                          ></i>
                        </Button>
                      </ReportCountDownload>
                      <Button
                        className="report-listing-filter-btn"
                        onClick={() => setIsCustomViewOpen(!isCustomViewOpen)}
                      >
                        <span className="mdi mdi-filter-variant"></span>
                      </Button>
                    </div>
                  </div>

                  <div
                    className="d-sm-flex align-items-start flex-row gap-2 justify-content-between"
                    style={{
                      width: "100%",
                    }}
                  >
                    <div className="d-flex gap-1 align-items-start">
                      <ExternalFilter
                        // Job timeline
                        customView={customView}
                        setCustomView={setCustomView}
                        setBubbleExternalFilter={setBubbleExternalFilter}
                        defaultCustomView={defaultCustomView}
                        // Job
                        jobCustomView={jobCustomView}
                        setJobCustomView={setJobCustomView}
                        setJobBubbleExternalFilter={setJobBubbleExternalFilter}
                        jobDefaultCustomView={jobDefaultCustomView}
                      />
                    </div>

                    <div className="d-flex gap-2">
                      <div
                        style={{
                          width: "210px",
                        }}
                      >
                        <div
                          className="d-flex justify-content-between mb-1"
                          onClick={() => setIsDateOpen(!isDateOpen)}
                          style={labelStyle}
                        >
                          <span className="fw-semibold">Date</span>
                          <i
                            className={`fw-bold 
                           ${
                             isDateOpen
                               ? "ri-arrow-up-s-line"
                               : "ri-arrow-down-s-line"
                           }
                        `}
                          ></i>
                        </div>
                        {isDateOpen && (
                          <Calendar
                            handleSubmit={applyDateRange}
                            selectedDates={selectedDates}
                            setSelectedDates={setSelectedDates}
                            dateValueObj={getDateObj(
                              customView?.externalFilters
                            )}
                            isDisabled={
                              getCurrentStageFilter(customView?.externalFilters)
                                ?.value === "true"
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          {bubbleExternalFilter && bubbleExternalFilter.length > 0 && (
            <Row>
              <Col lg={12}>
                <div className="page-title-box d-flex flex-row justify-content-between align-items-start">
                  <FilterBubbles
                    setBubbleExternalFilter={setBubbleExternalFilter}
                    bubbleExternalFilter={bubbleExternalFilter}
                  />
                </div>
              </Col>
            </Row>
          )}
          <div className="d-flex justify-content-end">
            <CurrentStageFilter
              value={
                getCurrentStageFilter(customView?.externalFilters)?.value ||
                currentStage?.value
              }
              onRetrieveCurrentStageData={handleCurrentStage}
              setCurrentStage={setCurrentStage}
            />
          </div>
          <Row className="report-cols">
            {getReportsData().map((report, index) => {
              const [key, value] = Object.entries(report)[0];
              return (
                <Row key={index} className="d-flex flex-column flex-wrap">
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <div className="report-listing-header">
                        {key}
                        {key == REPORT_CATEGORY.JOBS && (
                          <span className="job-cv-subtitle">
                            {jobCustomView?.name || "Default Job View"}
                          </span>
                        )}
                      </div>

                      {key == REPORT_CATEGORY.JOBS && (
                        <Button
                          className="report-listing-filter-btn d-flex justify-content-center align-items-center"
                          onClick={() =>
                            setIsJobCustomViewOpen(!isJobCustomViewOpen)
                          }
                          style={{
                            height: "25px",
                            width: "25px",
                          }}
                        >
                          <span className="mdi mdi-filter-variant"></span>
                        </Button>
                      )}
                    </div>
                    <ListGroup
                      className={`${
                        key === "Jobs" || key === "Jobs - FOD"
                          ? "job-details-listgroup"
                          : "report-listing-listgroup"
                      }`}
                    >
                      {value.map((reportItem, idx) => {
                        const hasBottomBorder =
                          reportTypeBorder.includes(reportItem);
                        return (
                          <ListGroupItem
                            key={idx}
                            className={`${
                              key === "Jobs" || key === "Jobs - FOD"
                                ? "job-details-listgroupitem"
                                : "report-listing"
                            }
                            ${
                              hasBottomBorder
                                ? "job-details-listgroupitem-border-bottom"
                                : ""
                            }
                          ${
                            selectedItem.key === key &&
                            selectedItem.value === reportItem &&
                            "report-listing-selected"
                          } ${
                              (selectedItem.key === "Jobs" ||
                                selectedItem.key === "Jobs - FOD") &&
                              selectedItem.value === reportItem &&
                              "job-details-selected"
                            }`}
                            style={{
                              cursor:
                                NOT_CLICKABLE_REPORTS.includes(reportItem) &&
                                "default",
                            }}
                            onClick={() => {
                              if (NOT_CLICKABLE_REPORTS.includes(reportItem)) {
                                return;
                              }
                              setIsReportOffcanvasOpen(!isReportOffcanvasOpen);
                              setSelectedItem({ key, value: reportItem });
                            }}
                          >
                            <div className="report-content">
                              <div className="d-flex flex-row justify-content-center align-items-center gap-2">
                                {(key === "Jobs" || key === "Jobs - FOD") && (
                                  <img src={getJobIcons(reportItem)} />
                                )}
                                <span>{reportItem}</span>
                                {getReportInformation(key, reportItem) && (
                                  <InformationToolTip
                                    informationText={getReportInformation(
                                      key,
                                      reportItem
                                    )}
                                  />
                                )}
                              </div>

                              <span
                                className={`report-listing-count ${
                                  selectedItem.key === key &&
                                  selectedItem.value === reportItem &&
                                  "report-listing-count-selected"
                                } ${
                                  (selectedItem.key === "Jobs" ||
                                    selectedItem.key === "Jobs - FOD") &&
                                  selectedItem.value === reportItem &&
                                  "job-details-count-selected"
                                }`}
                              >
                                {reportCountMeta?.isLoading ||
                                reportJobCountMeta?.isLoading ? (
                                  <Spinner size="sm" />
                                ) : getReportCount(key, reportItem) ? (
                                  getReportCount(key, reportItem)
                                ) : (
                                  0
                                )}
                              </span>
                            </div>
                          </ListGroupItem>
                        );
                      })}
                    </ListGroup>
                  </div>
                </Row>
              );
            })}
          </Row>
          {generateOffCanvas(selectedItem.key, selectedItem.value)}
          <TimelineCustomView
            isOpen={isCustomViewOpen}
            setIsOpen={setIsCustomViewOpen}
            customView={customView}
            setCustomView={setCustomView}
            setBubbleExternalFilter={setBubbleExternalFilter}
            title="Custom View (Job Timeline)"
            initializeDefaultFilterStages={initializeDefaultFilterStages}
            // Job
            setJobBubbleExternalFilter={setJobBubbleExternalFilter}
            jobBubbleExternalFilter={jobBubbleExternalFilter}
          />
          <JobReportCustomViewCanvas
            isFilterOpen={isJobCustomViewOpen}
            setIsFilterOpen={setIsJobCustomViewOpen}
            title="Custom View (Jobs)"
            jobCustomView={jobCustomView}
            setJobCustomView={setJobCustomView}
            setJobBubbleExternalFilter={setJobBubbleExternalFilter}
            initializeDefaultFilterStages={initializeDefaultFilterStages}
            // Jobtimeline
            setBubbleExternalFilter={setBubbleExternalFilter}
            bubbleExternalFilter={bubbleExternalFilter}
          />
        </Container>
      </div>
    </UniversalReportProvider>
  );
}

export default UniversalReport;
